import { render, staticRenderFns } from "./ComboBoxItem.vue?vue&type=template&id=2c7be116&scoped=true"
import script from "./ComboBoxItem.vue?vue&type=script&lang=ts"
export * from "./ComboBoxItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7be116",
  null
  
)

export default component.exports